import './TagColorSection.scss';
import { coreActions } from '@sonar-software/sonar-core';
import { SonarText } from '@ui/text';
import { ColorPicker, Space } from 'antd';
import { COPY_SPECIFIC, TAG_COLORS } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useState } from 'react';
import { useAction, useTagReference } from '@hooks';
const presets = [{
        colors: TAG_COLORS,
        label: ''
    }];
export const TagColorSection = ({ getPopupContainer, tagId }) => {
    var _a;
    const tag = useTagReference(tagId);
    const [currentColor, setCurrentColor] = useState((_a = tag.hexColor) !== null && _a !== void 0 ? _a : TAG_COLORS[0]);
    const requestPut = useAction(coreActions.requestPutCoreTagsById);
    const handleChange = useCallback((open) => {
        if (tagId && !open && tag.hexColor !== currentColor) {
            requestPut(Object.assign(Object.assign({}, tag), { hexColor: currentColor }));
        }
    }, [currentColor, requestPut, tag, tagId]);
    return (React.createElement(Space, { align: 'center', className: 'tag-color-section', direction: 'vertical', size: 4 },
        React.createElement(SonarText, { size: 16, weight: 'semibold' }, COPY_SPECIFIC.COLOR),
        React.createElement(ColorPicker, { disabled: tag.autoTagged, disabledAlpha: true, format: 'hex', getPopupContainer: getPopupContainer, onChange: (color) => {
                setCurrentColor(color.toHexString());
            }, onOpenChange: handleChange, presets: presets, value: currentColor })));
};
